module.exports = __webpack_public_path__ + "img/touch_white.1611afd0.png";